import { Injectable } from "@angular/core";
import { RatingViewModel, RatingDataModel } from "../../shared/models";
import { RatingService } from "../../services/rating.service";
import { FeedbackService } from "../../services/feedback.service";
import { ContentType } from "../../shared/contentTypes";

@Injectable({
  providedIn: "root"
})
export class RatingDialogService {
  constructor(private _ratingService: RatingService
    , private _feedbackService: FeedbackService) {
  }

  /** Get RatingDataModel and map data to view model
   * @param contentType type of content for getting related rate
   * @param contentID ID of content for getting related rate
   * @result return RateViewModel.
   */
  public GetRatingViewModel(contentType: ContentType, contentID: number): Promise<RatingViewModel> {
    const me = this;
    let ratingViewModel: RatingViewModel;
    return new Promise<RatingViewModel>((resolve, reject) => {
      me._ratingService.GetRating(contentType, contentID)
        .then(rateDataModel => {
          if (rateDataModel) {
            ratingViewModel = me.mapDataModelToViewModel(rateDataModel);
          }
          resolve(ratingViewModel);
        })
        .catch(reject);
    });
  }

  public SaveRatingViewModel(ratingViewModel: RatingViewModel): Promise<void> {
    const me = this;
    return me._ratingService.SetRating(ratingViewModel.message, RatingService.StarsToRating(ratingViewModel.rating), ratingViewModel.content_type, ratingViewModel.content_id);
  }

  public SaveFeedbackRatingViewModel(message: string, rating: number): Promise<void> {
    const me = this;
    return me._feedbackService.AddFeedback(message, rating);
  }

  // Mapper

  private mapDataModelToViewModel(rateDataModel: RatingDataModel): RatingViewModel {
    const ratingViewModel: RatingViewModel = new RatingViewModel();
    ratingViewModel.content_id = rateDataModel.content_id;
    ratingViewModel.content_type = rateDataModel.content_type;
    ratingViewModel.rating = RatingService.RatingToStars(rateDataModel.rating);
    ratingViewModel.message = rateDataModel.message;
    return ratingViewModel;
  }
}
